import * as THREE from 'three'
import * as dat from 'lil-gui'

import { MathUtils } from 'three'

import Experience from "./Experience"

export default class GUI
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.sceneMain
        this.camera = this.experience.camera
        this.renderer = this.experience.renderer
        this.particleObjects = this.experience.particleObjects

        this.particleObjects.on("ready", () => {this.initGUI()})
    }

    initGUI()
    {
        this.gui = new dat.GUI()
        this.gui.close()
        
        this.initScroll()
        this.initOptions()
        this.initProxyMouse()
        this.initFragmentShaer()
        
        this.gui.hide()
    }

    initScroll()
    {
        this.scrollFolder = this.gui.addFolder("Scroll")
        this.scrollFolder.add(this.particleObjects.guiValues, "scroll", 0.0, 100.0, 0.1).onChange
        (
            value => 
            { 
                this.camera.setScrollValue(value)
                this.particleObjects.setState() 
            }
        )
        this.scrollFolder.add(this.experience.camera.instance, "fov", 0.0, 100.0, 1.0).name("fov").onChange(value => { this.experience.camera.setFOV(value) })
    }

    initOptions()
    {
        this.optionsFolder = this.gui.addFolder("Options")
        // this.optionsFolder.add(this.particleObjects.guiValues, "mode", ["Multiple", "Single"]).onChange(value => { this.particleObjects.setMode(value) })
        this.optionsFolder.add(this.particleObjects.guiValues, "particlesSpeed", 0.1, 2.0, 0.1).onChange(value => { this.particleObjects.guiValues.particlesSpeed = value })
        this.optionsFolder.add(this.particleObjects.guiValues, "objectsSpeed", 0.1, 2.0, 0.1).onChange(value => { this.particleObjects.guiValues.objectsSpeed = value })
        this.optionsFolder.add(this.particleObjects.guiValues, "objectsFocusSpeed", 0.1, 2.0, 0.1).onChange(value => { this.particleObjects.guiValues.objectsFocusSpeed = value })
        this.optionsFolder.add(this.particleObjects.guiValues, "objectFocus").onChange(value => { this.particleObjects.guiValues.objectFocus = value })
        this.optionsFolder.add(this.particleObjects.guiValues, "mouseRadiusMagnet", 0.0, 1.0, 0.01).onChange(value => { this.particleObjects.setMouseRadiusMagnet(value) })
        this.optionsFolder.add(this.particleObjects.guiValues, "mouseRadiusColor", 0.0, 1.0, 0.01).onChange(value => { this.particleObjects.setMouseRadiusColor(value) })
        this.optionsFolder.add(this.particleObjects.guiValues, "showMouseFollower").onChange(value => { this.particleObjects.setShowMouseFollower(value) })
        this.optionsFolder.add(this.particleObjects.guiValues, "mouseFollowerDelta", 0.0, 1.0, 0.01).onChange(value => { this.particleObjects.guiValues.mouseFollowerDelta = value })
        this.optionsFolder.add(this.particleObjects.guiValues, "mouseMagnet").onChange(value => { this.particleObjects.guiValues.mouseMagnet = value })
        this.optionsFolder.add(this.particleObjects.guiValues.onHoverOffset, "x", 0.0, 0.1, 0.005).name("onHoverOffsetX").onChange(value => { this.particleObjects.setOnHoverOffset(new THREE.Vector2(value, this.particleObjects.guiValues.onHoverOffset.y)) })
        this.optionsFolder.add(this.particleObjects.guiValues.onHoverOffset, "y", -10.0, 10.0, 0.05).name("onHoverOffsetY").onChange(value => { this.particleObjects.setOnHoverOffset(new THREE.Vector2(this.particleObjects.guiValues.onHoverOffset.x, value)) })
    }
    
    initProxyMouse()
    {
        this.proxyMouseFolder = this.gui.addFolder("Proxy Mouse")        
        this.proxyMouseFolder.add(this.particleObjects.guiValues, "proxyMouseRadius", 0.0, 60.0, 0.05).onChange(value => { this.particleObjects.guiValues.proxyMouseRadius = value })
        this.proxyMouseFolder.add(this.particleObjects.guiValues, "proxyMouseOffset", -10.0, 10.0, 0.05).onChange(value => { this.particleObjects.guiValues.proxyMouseOffset = value })
        this.proxyMouseFolder.add(this.camera, "proxyMouseDebug").onChange(value => 
        {
            this.camera.proxyMouseDebug = value

            if (value) this.camera.proxyMouse.geometry = new THREE.SphereGeometry(0.01, 16.0, 16.0)
            else this.camera.proxyMouse.geometry = new THREE.SphereGeometry(0.0, 1.0, 1.0)
        })
        this.proxyMouseFolder.add(this.camera.proxyMouseDebugRange, "x", 0.0, 100.0, 0.5).name("proxyMouseDebugRangeX").onChange(value => { this.camera.proxyMouseDebugRange = new THREE.Vector2(value, this.camera.proxyMouseDebugRange.y) })
        this.proxyMouseFolder.add(this.camera.proxyMouseDebugRange, "y", 0.0, 100.0, 0.5).name("proxyMouseDebugRangeY").onChange(value => { this.camera.proxyMouseDebugRange = new THREE.Vector2(this.camera.proxyMouseDebugRange.x, value) })
        this.proxyMouseFolder.add(this.camera, "proxyMouseDebugPositionX", -2.0, 2.0, 0.05).onChange(value => { this.camera.proxyMouseDebugPositionX = value })
    }

    initFragmentShaer()
    {
        this.fragmentShaerFolder = this.gui.addFolder("Fragment Shader")
        this.fragmentShaerFolder.add(this.particleObjects.guiValues, "colorHalo", 0.0, 1.0, 0.05).onChange(value => { this.particleObjects.setColorHalo(value) })
        this.fragmentShaerFolder.add(this.particleObjects.guiValues.opacityRange, "x", 0.0, 1.0, 0.05).name("opacityRangeX").onChange(value => { this.particleObjects.setOpacityRange(value, this.particleObjects.guiValues.opacityRange.y) })
        this.fragmentShaerFolder.add(this.particleObjects.guiValues.opacityRange, "y", 0.0, 1.0, 0.05).name("opacityRangeY").onChange(value => { this.particleObjects.setOpacityRange(this.particleObjects.guiValues.opacityRange.x, value) })
        // this.fragmentShaerFolder.add(this.particleObjects.guiValues.zRange, "x", 2.0, 4.0, 0.1).name("zRangeX").onChange(value => { this.particleObjects.setZRange(value, this.particleObjects.guiValues.zRange.x) })
        // this.fragmentShaerFolder.add(this.particleObjects.guiValues.zRange, "y", 2.0, 4.0, 0.1).name("zRangeY").onChange(value => { this.particleObjects.setZRange(this.particleObjects.guiValues.zRange.y, value) })
    }
}